import Dialog from "components/AppDialog/components/Dialog/Dialog";
import { ReactComponent as ErrorOutlineIcon } from "../../../../images/payment_check_circle.svg";
import { VStack } from "../../../Stack";
import Button from "../../../formElements/Button/Button";
import "./PaymentSucceedModal.css";
import {
  isSelfStudyItem,
  periodToString,
  PricingModelItem,
} from "../../../../model/pricingmodel";
import moment from "moment/moment";

interface Props {
  onClose: () => void;
  plan: PricingModelItem;
}

// TODO: unite with PaymentFailedModal
export default function PaymentSucceedModal({ onClose, plan }: Props) {
  let text;
  if (isSelfStudyItem(plan)) {
    const period = periodToString(plan.length!);
    const nextPaymentDate = moment().add(plan.length, "days").format("MMMM D, YYYY");
    text = (
      <p>
        Your payment has been successfully processed. You are now subscribed at $
        {plan.price} per {period}. Please note, your next payment will be on{" "}
        {nextPaymentDate}. Thank you for your subscription!
      </p>
    );
  } else {
    text = (
      <p>Your payment has been successfully processed. Thank you for your purchase!</p>
    );
  }

  return (
    <Dialog
      showDialog={true}
      onClose={onClose}
      closeOnOuterClick={false}
      className={"app-dialog payment-succeed"}
    >
      <VStack className="container" align={"center"} gap={32}>
        <div className="header-rect" />
        <VStack align={"center"} gap={24} justify={"space-evenly"}>
          <ErrorOutlineIcon />
          <p className="header">Payment Successful</p>
          {text}
          <Button className="payment-btn continue" onClick={onClose}>
            Continue
          </Button>
        </VStack>
      </VStack>
    </Dialog>
  );
}
